<div class="py-3">
  <div class="mb-6">
    <div class="flex items-baseline justify-between gap-3 mb-3">
      <h2 class="text-base font-semibold">Out of Stock</h2>
      <a class="link link-primary text-sm" [routerLink]="['/products']" [queryParams]="{filter: 'outOfStock', back: 'shopping'}">View
        all</a>
    </div>

    <app-out-of-stock-products-teaser
      [householdId]="context().household?.id"
      [limit]="40"
    />
  </div>

  @if (errorMessage) {
    <div class="alert alert-error shadow-sm" role="alert">
      {{ errorMessage }}
    </div>
  }

  @if (isLoading) {
    <div class="flex items-center gap-3 text-base-content/70">
      <span class="loading loading-spinner loading-sm"></span>
      <span>Loading export links…</span>
    </div>
  } @else {
    @if (Object.keys(shoppingLinks).length === 0) {
      <div class="alert bg-base-100 border shadow-sm" role="alert">
        <span>No export providers available.</span>
      </div>
    } @else {

      <div class="flex items-baseline justify-between gap-3 mb-3">
        <h2 class="text-base font-semibold">Export to your shopping list</h2>
      </div>

      <ui-list variant="bordered">
        @for (link of linksArray; track link.key) {
          <ui-list-item>
            <div class="flex w-full items-center gap-4">
              <div class="avatar shrink-0">
                <div class="w-12 h-12 rounded-xl bg-base-200 flex items-center justify-center">
                  @if (providerLogoUrl(link.key)) {
                    <img class="w-full h-full object-contain rounded-xl" [src]="providerLogoUrl(link.key)!"
                         [alt]="link.key"/>
                  } @else {
                    <fa-icon [icon]="faLink"></fa-icon>
                  }
                </div>
              </div>

              <div class="min-w-0 flex-1">
                <div class="font-medium truncate">{{ link.key }}</div>
                <div class="text-xs text-base-content/60 truncate">Export your shopping list to {{ link.key }}</div>
              </div>

              <div class="shrink-0">
                <ui-button variant="primary" [href]="resolveProviderAction(link.key, link.value)" target="_blank"
                           rel="noopener noreferrer">
                  Export
                </ui-button>
              </div>
            </div>
          </ui-list-item>
        }
      </ui-list>
    }
  }
</div>
